import React from 'react';
import { Grid, Icon, Form } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { InputField } from 'Common/SemanticWrapper';
import { CreateEditPurchaseOrderEnum } from 'Common/FieldEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { ItemGridFormField } from 'Components';
import { OrdertypeEnum } from 'Common/Constants/Enumeration/ManagePurchaseOrderEnum';

import {
  getTotalTaxCostAmount,
  getTotalCostAmount,
  getTotalMerchandiseAmount,
} from './../../helper';

const PreviewPurchaseOrderComponent = props => {
  const {
    poItemDetails,
    onResetPageOnDataChange,
    resetPageOnDataChange,
    isEditPage,
    isDisabled,
    IsWarehouseOrder,
  } = props;

  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Field
              name={CreateEditPurchaseOrderEnum.Comments}
              component={InputField}
              type="text"
              maxLength={50}
              label={'Comments'}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={4}>
          <Grid.Column width={3}>
            <label className={'text-orange'}>
              Order Items(
              {poItemDetails && poItemDetails.length})
            </label>
          </Grid.Column>
          <Grid.Column width={5}>
            <label className={'text-orange'}>
              Total merchandise cost: <Icon name={'dollar'} />
              {getTotalMerchandiseAmount(poItemDetails)}
            </label>
          </Grid.Column>
          <Grid.Column width={5}>
            <label className={'text-orange'}>
              Total tax cost: <Icon name={'dollar'} />
              {getTotalTaxCostAmount(poItemDetails)}
            </label>
          </Grid.Column>
          <Grid.Column width={3}>
            <label className={'text-orange'}>
              Total cost: <Icon name={'dollar'} />
              {getTotalCostAmount(poItemDetails)}
            </label>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <hr />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Field
              component={ItemGridFormField}
              name={CreateEditPurchaseOrderEnum.POItemDetails}
              {...{
                dataSource: poItemDetails,
                isPreviewPage: true,
                gridName: GridEnum.INV_ManagePurchaseOrder_CreateEdit_View,
                tableName: TableNamesEnum.PURCHASE_ORDER_CREATE_EDIT_TABLE,
                onResetPageOnDataChange: onResetPageOnDataChange,
                resetPageOnDataChange: resetPageOnDataChange,
                disabled:
                  isDisabled ||
                  (isEditPage && IsWarehouseOrder !== OrdertypeEnum.PO),
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

PreviewPurchaseOrderComponent.propTypes = {
  poItemDetails: PropTypes.array.isRequired,
  onResetPageOnDataChange: PropTypes.func,
  resetPageOnDataChange: PropTypes.bool,
  isEditPage: PropTypes.bool,
};
export default PreviewPurchaseOrderComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/components/createEditPurchaseOrder/PreviewPurchaseOrder.js